import React, { ReactChild } from "react";
import {
    ChapterTree,
    tempDataProps
} from "../../../../../../../../service/CourseDetail/chapter";
import { Tree } from "antd";
import Style from "./index.module.scss";
import lodash from "lodash-es";
import className from "classnames";

const { TreeNode } = Tree;

export interface QuoteTabItemProps {
    data: tempDataProps;
    children: ReactChild;
    active: boolean;
}

const Index = ({ data, children, active }: QuoteTabItemProps) => {
    function renderTreeNodes(data: ChapterTree[]) {
        return data.map((item, index) => {
            console.log(item);
            if (item.children && item.children.length > 0) {
                return (
                    <ul key={`c_${index}_${item.id}_${lodash.random(19999)}`}>
                        <li>{item.chapterName}</li>
                        <ul>{renderTreeNodes(item.children)}</ul>
                    </ul>
                );
            } else {
                return (
                    <React.Fragment
                        key={`c_${index}_${item.id}_${lodash.random(19999)}`}>
                        <li>
                            <span>{item.chapterName}</span>
                        </li>
                    </React.Fragment>
                );
            }
        });
    }
    return (
        <div className={className(Style.root, `${active ? Style.active : ""}`)}>
            {data && (
                <ul className={Style.ul}>
                    {renderTreeNodes(data.sourceChapterTemplateTree.children)}
                </ul>
            )}
            {children}
        </div>
    );
};

export default Index;
